var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _ProductStickyBuyButton_instances, showLoading_fn, hideLoading_fn;
import { C as Component } from "./component-cLJ9vlHA.js";
import { C as CustomEvents, T as ThemeAlertOpenEvent } from "./events-DeC3n8dp.js";
import { m as morph } from "./morph-BX9Iqu9G.js";
import { a as lazyReveal } from "./utilities-2Suih3Nm.js";
import "./critical-Da0Dmhh9.js";
class ProductStickyBuyButton extends Component {
  constructor() {
    super();
    __privateAdd(this, _ProductStickyBuyButton_instances);
    this.sectionId = this.dataset.sectionId;
    this.originalProductForm = document.querySelector(`product-form[data-section-id="${this.sectionId}"]`);
    this.handleVariantPickerUpdate = this.handleVariantPickerUpdate.bind(this);
    this.setupObservers = this.setupObservers.bind(this);
    this.updateVisibility = this.updateVisibility.bind(this);
    this.targetSelector = ".js-product-buy-buttons";
    this.footerSelector = ".js-footer";
    this.showClass = "fade-in-up";
    this.section = null;
    this.initialized = false;
    this.isTargetPassed = false;
    this.isFooterVisible = false;
    this.isShowing = false;
    this.targetObserver = null;
    this.footerObserver = null;
  }
  connectedCallback() {
    super.connectedCallback();
    if (!this.section && this.closest(".shopify-section")) {
      this.section = this.closest(".shopify-section");
    }
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
      return;
    }
    if (this.initialized) return;
    this.initialized = true;
    if (this.section) {
      this.section.addEventListener(CustomEvents.variantPickerUpdate, this.handleVariantPickerUpdate);
    }
    this.setupObservers();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (!this.initialized) return;
    if (this.targetObserver) this.targetObserver.disconnect();
    if (this.footerObserver) this.footerObserver.disconnect();
    if (this.section) {
      this.section.removeEventListener(CustomEvents.variantPickerUpdate, this.handleVariantPickerUpdate);
      this.section = null;
    }
  }
  setupObservers() {
    const target = document.querySelector(this.targetSelector);
    const footer = document.querySelector(this.footerSelector);
    if (target) {
      this.targetObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isTargetPassed = false;
          } else {
            if (entry.boundingClientRect.bottom < 0) {
              this.isTargetPassed = true;
            } else {
              this.isTargetPassed = false;
            }
          }
          this.updateVisibility();
        });
      }, {
        threshold: 0,
        rootMargin: "0px"
      });
      this.targetObserver.observe(target);
    }
    if (footer) {
      this.footerObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.isFooterVisible = entry.isIntersecting;
          this.updateVisibility();
        });
      }, {
        threshold: 0,
        rootMargin: "0px"
      });
      this.footerObserver.observe(footer);
    }
  }
  updateVisibility() {
    const shouldShow = this.isTargetPassed && !this.isFooterVisible;
    if (this.isShowing === shouldShow) return;
    this.isShowing = shouldShow;
    if (shouldShow) {
      this.classList.add(this.showClass);
    } else {
      this.classList.remove(this.showClass);
    }
  }
  /**
   * Handle variant picker update event
   * Updates the sticky media image and price when variant changes
   */
  handleVariantPickerUpdate(event) {
    var _a;
    if (!((_a = event.detail) == null ? void 0 : _a.data)) return;
    const { productId, html } = event.detail.data;
    if (productId && productId !== this.dataset.productId) {
      return;
    }
    if (!html) return;
    const tag = this.tagName.toLowerCase();
    let selector = tag;
    if (this.dataset.productId) {
      selector = `${tag}[data-product-id="${this.dataset.productId}"]`;
    }
    const newComponent = html.querySelector(selector);
    if (newComponent) {
      morph(this, newComponent);
      lazyReveal(this);
    }
  }
  async addToCart(event) {
    event.preventDefault();
    const { addToCartButton } = this.refs;
    if (!addToCartButton) return;
    __privateMethod(this, _ProductStickyBuyButton_instances, showLoading_fn).call(this, event);
    try {
      await this.originalProductForm.handleSubmit(event);
    } catch (error) {
      this.dispatchEvent(new ThemeAlertOpenEvent(error, "error"));
    } finally {
      __privateMethod(this, _ProductStickyBuyButton_instances, hideLoading_fn).call(this, event);
    }
  }
}
_ProductStickyBuyButton_instances = new WeakSet();
showLoading_fn = function() {
  const { addToCartButton } = this.refs;
  if (addToCartButton) {
    addToCartButton.setAttribute("loading", "true");
  }
};
hideLoading_fn = function() {
  const { addToCartButton } = this.refs;
  if (addToCartButton) {
    addToCartButton.removeAttribute("loading");
  }
};
if (!customElements.get("product-sticky-buy-button")) {
  customElements.define("product-sticky-buy-button", ProductStickyBuyButton);
}
